import { rem } from 'polished'
import React from 'react'
import styled, { keyframes, useTheme } from 'styled-components'
import { SVG_ICON_SIZE_CSS_VAR, SvgIconComponent, StyledSvgIcon } from 'LuxKit/SvgIcon'
import { setCSSVar } from 'lib/theme/themeUtils'
import MapSelectItemPin from './MapSelectItemPin'

export const SELECTED_PIN_WIDTH = 40
export const SELECTED_PIN_HEIGHT = 48

const Pop = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`

const StyledSvg = styled.svg`
  pointer-events: none;
  overflow: visible;
  z-index: 9999;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }
`

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;
  animation: ${Pop} 0.5s ease;
`

const NumberContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 80%;
  color: ${(props) => props.theme.palette.neutral.default.eight};
  font-size: ${rem(18)};
  font-weight: bold;
  user-select: none;
`

const IconContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: ${rem(10)};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: ${(props) => props.theme.palette.neutral.default.eight};

  > ${StyledSvgIcon} {
    ${setCSSVar(SVG_ICON_SIZE_CSS_VAR, '50%')}
  }
`
interface Props {
  pinColour?: string
  number?: number
  icon?: SvgIconComponent
  strokeColour?: string
  iconColour?: App.Design.ContentColour
  text?: string
}

function SelectedMapItemPin({ pinColour, number, icon: Icon, strokeColour, iconColour, text }: Props) {
  const theme = useTheme()

  if (!pinColour) {
    return <MapSelectItemPin text={text || ''} />
  }
  return (
    <Container>
      <StyledSvg
        width={SELECTED_PIN_WIDTH}
        height={SELECTED_PIN_HEIGHT}
        viewBox={`0 0 ${SELECTED_PIN_WIDTH} ${SELECTED_PIN_HEIGHT}`}
      >
        <path
          d="M34.9605 32.3403L33.8892 33.6915H33.9693L20.2031 49.0747C20.0932 49.1973 19.907 49.1973 19.797 49.0747L6.03073 33.6915H6.11082L5.03947 32.3403C2.40789 29.0213 0.833333 24.8047 0.833333 20.2203C0.833333 9.50458 9.42313 0.833333 20 0.833333C30.5769 0.833333 39.1667 9.50458 39.1667 20.2203C39.1667 24.8047 37.5921 29.0213 34.9605 32.3403Z"
          fill={pinColour || theme.palette.neutral.default.three}
          stroke={strokeColour}
          strokeWidth="2.5"
        />
      </StyledSvg>
      {Icon && <IconContainer><Icon colour={iconColour} /></IconContainer>}
      {number && !Icon && <NumberContainer>{number}</NumberContainer>}
    </Container>
  )
}

export default SelectedMapItemPin
